import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Clientes } from "../../Clientes/Clientes";
import { Personal } from "../../Personal/Personal";
import { Tiendas } from "../../Tiendas/Tiendas";

const currentDate = new Date();

const columns = () =>
(
    {
        vc_clientes: new EntityColumn<string[]>({ name: 'vc_clientes', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Clientes', isArray: true }),
        vc_tiendas: new EntityColumn<string[]>({ name: 'vc_tiendas', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tiendas', isArray: true }),
        vc_personal: new EntityColumn<string[]>({ name: 'vc_personal', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal', isArray: true }),
        d_fecha_visita_desde: new EntityColumn<Date>({ name: 'd_fecha_visita_desde', type: 'date', flags: c.Edit, prompt: 'Fecha Visita Desde', defaultValue: currentDate }),
        d_fecha_visita_hasta: new EntityColumn<Date>({ name: 'd_fecha_visita_hasta', type: 'date', flags: c.Edit, prompt: 'Fecha Visita Hasta', defaultValue: currentDate }),
        c_estado_visita_id: new EntityColumn<string>({ name: 'c_estado_visita_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Estado Visita' }),
        ...DefaultColumns()
    }
)

const lookups = () =>
(
    {
        'Clientes': {
            name: 'Clientes',
            viewMapping: { keyIndex: 0, descriptionIndex: 2 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Clientes(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 4 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Tiendas(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },
    }
)

export class DatosServiciosAutorizacionReportesAppSupervisorFiltersDef extends EntityDefinition {

    columns = columns();
    views = {};
    lookups = lookups();

    constructor() {
        super('DatosServiciosAutorizacionReportesAppSupervisorFilters');
    }
}